import { useState } from "react";
import TextField from '@mui/material/TextField';
import flatpickr from "flatpickr";
import { Czech } from "flatpickr/dist/esm/l10n/cs";
import CSS from 'csstype';
import { beDateToLocal, dateToBe } from "~/utils/date";
import { langStore } from "~/stores/lang";
import { LANG_CS } from "~/const";

interface IState {
	set: boolean;
}

interface IDateInput {
	value: string;
	onChange: (newDate: Date, data: { local: string; be: string; }) => void;
	label?: string;
	sx?: CSS.Properties;
	minDate?: Date;
	maxDate?: Date;
}

export default function DateInput({
	label = "",
	onChange = () => {},
	value = "",
	minDate = null,
	maxDate = null,
	sx = {},
}: IDateInput) {
	const [state, setState] = useState<IState>({
		set: false,
	});

	function setInput(target: HTMLElement) {
		if (!state.set) {
			flatpickr(target, {
				enableTime: false,
				// stejny format jako zobrazena hodnota (beDateToLocal), aby flatpickr do pole nezapsal jiny tvar
				formatDate: date => beDateToLocal(dateToBe(date)),
				disableMobile: true,
				position: "below center",
				positionElement: target,
				monthSelectorType: "static",
				allowInput: false,
				onChange: (selectedDates, local) => {
					onChange(selectedDates[0], {
						local,
						be: dateToBe(selectedDates[0]),
					});
				},
				...minDate ? { minDate } : {},
				...maxDate ? { maxDate } : {},
				// cestina ma vlastni lokalizaci, v anglictine vychozi anglicka s tydnem od pondeli (en-GB)
				locale: langStore.getState().lang === LANG_CS
					? Czech
					: { firstDayOfWeek: 1 },
			});
			setState(prev => ({
				...prev,
				set: true,
			}));
		}
	}

	return <TextField
		label={label}
		value={value || ""}
		onChange={() => {}}
		onPointerDown={event => setInput(event.target as HTMLElement)}
		size="small"
		inputProps={{
			autoComplete: "off",
		}}
		sx={{ width: "100%", background: "var(--theme-inputBg)", ...sx }}
	/>;
}
